import { Action } from '@ngrx/store';
import { UploadStatus } from './new.reducer';

export const START_UPLOAD = '[New] Start Upload';
export const INIT_UPLOAD = '[New] Init Upload';
export const SET_PROJECT_ID = '[New] Set Project Id';
export const SET_PROJECT_TITLE = '[New] Set Project Title';
export const SET_IS_PROJECT_UPDATING = '[New] Set Is Project Updating';
export const UPDATE_STATUS = '[New] Update Status';
export const UPDATE_SUBMITTING = '[New] Update Submitting';
export const MOUSE_LEAVED = '[New] Mouse Leaved';
export const WARNING_MESSAGE_CLOSED = '[New] Warning Message Closed';

export class InitUpload implements Action {
  readonly type = INIT_UPLOAD;
}

export class StartUpload implements Action {
  readonly type = START_UPLOAD;
}

export class SetProjectId implements Action {
  readonly type = SET_PROJECT_ID;

  constructor(public payload: string) {}
}

export class SetProjectTitle implements Action {
  readonly type = SET_PROJECT_TITLE;

  constructor(public payload: string) {}
}

export class SetIsProjectUpdating implements Action {
  readonly type = SET_IS_PROJECT_UPDATING;

  constructor(public payload: boolean) {}
}

export class UpdateStatus implements Action {
  readonly type = UPDATE_STATUS;

  constructor(public payload: UploadStatus) {}
}

export class UpdateSubmitting implements Action {
  readonly type = UPDATE_SUBMITTING;

  constructor(public payload: boolean) {}
}

export class MouseLeaved implements Action {
  readonly type = MOUSE_LEAVED;
}

export class WarningMessageClosed implements Action {
  readonly type = WARNING_MESSAGE_CLOSED;
}

export type NewActions =
  | InitUpload
  | StartUpload
  | SetProjectId
  | SetProjectTitle
  | SetIsProjectUpdating
  | UpdateStatus
  | UpdateSubmitting
  | MouseLeaved
  | WarningMessageClosed;
